"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAssetInfoValidator = void 0;
const ts_types_1 = require("@waves/ts-types");
const validators_1 = require("./validators");
const updateAssetInfoScheme = {
    type: validators_1.isEq(ts_types_1.TRANSACTION_TYPE.UPDATE_ASSET_INFO),
    senderPublicKey: validators_1.isPublicKey,
    name: validators_1.isValidAssetName,
    description: validators_1.isValidAssetDescription,
    version: validators_1.orEq([1]),
    assetId: validators_1.isAssetId,
    feeAssetId: validators_1.isAssetId,
    fee: validators_1.isNumberLike,
    timestamp: validators_1.isNumber,
    proofs: validators_1.ifElse(validators_1.isArray, validators_1.defaultValue(true), validators_1.orEq([undefined])),
};
exports.updateAssetInfoValidator = validators_1.validateByShema(updateAssetInfoScheme, validators_1.getError);
//# sourceMappingURL=update-asset-info.js.map